import { takeEvery, put, call } from 'redux-saga/effects';
import { createEffect } from './creator';

import {
    getTeamList, getTeams,
    SALES_TEAM_GET, SALES_TEAM_GET_ALL,
} from '../actions/sales';
import UserApi from 'pc-sales/api.v2/user';

export default [
    // 获取设置
    takeEvery(SALES_TEAM_GET, createEffect(
        function* (action: Action.Async): any {
            try {
                const { data, totalCounts } = yield call(UserApi.sales.team.getList, action.payload);
                yield put(getTeams.succeeded({ data, totalCounts }));
                yield put(getTeamList.succeeded(data));
            } catch (err) {
                yield put(getTeams.failed());
                throw err;
            }
        }
    )),
    // 获取设置
    takeEvery(SALES_TEAM_GET_ALL, createEffect(
        function* (): any {
            try {
                const { data } = yield call(UserApi.sales.team.get, { pagesize: 0 });
                yield put(getTeamList.succeeded(data));
            } catch (err) {
                yield put(getTeams.failed());
                throw err;
            }
        }
    ))
];
